module.exports = __webpack_public_path__ + "img/empty.5b87279e.png";